<template>
    <div>
      Add Site
    </div>
</template>

<script>

import Cookies from 'js-cookie'

export default {
  name: 'AddSite',

  mounted () {
    sessionStorage.setItem('bm-siteconfig', atob(this.$route.params.config))

    if (!Cookies.get('bm-token')) {
      this.$router.push('/login')
    } else {
      this.$router.push('/sites')
    }
  }
}
</script>
